import { baseTypography } from '../default/baseTypography';
import { defaultDarkTheme, defaultLightTheme, sharedThemeValues } from '../default/default';
const olympicHeadlineExtraLarge = {
    untilMd: {
        fontSize: '36px',
        fontWeight: '900',
        lineHeight: '1',
        letterSpacing: '-0.00625em',
        fontFamily: baseTypography.font.family.sanSerif,
    },
    fromMd: {
        fontSize: '56px',
        fontWeight: '900',
        lineHeight: '1',
        letterSpacing: '-0.005em',
        fontFamily: baseTypography.font.family.sanSerif,
    },
};
const olympicBodyLarge = {
    untilMd: {
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '1.6875',
        letterSpacing: '0.05em',
        fontFamily: baseTypography.font.family.sanSerif,
    },
    fromMd: {
        fontSize: '22px',
        fontWeight: '400',
        lineHeight: '1.636',
        letterSpacing: '0.05em',
        fontFamily: baseTypography.font.family.sanSerif,
    },
};
const olympicTypography = {
    ...sharedThemeValues.typography,
    headline: {
        ...sharedThemeValues.typography.headline,
        extraLarge: olympicHeadlineExtraLarge,
        large: olympicHeadlineExtraLarge,
        medium: olympicHeadlineExtraLarge,
        small: olympicHeadlineExtraLarge,
    },
    body: {
        ...sharedThemeValues.typography.body,
        large: olympicBodyLarge,
    },
    effect: {
        ...sharedThemeValues.typography.effect,
        uppercase: {
            letterSpacing: undefined,
        },
    },
};
export const olympicLightTheme = {
    ...defaultLightTheme,
    typography: olympicTypography,
    name: 'olympicLight',
};
export const olympicDarkTheme = {
    ...defaultDarkTheme,
    typography: olympicTypography,
    name: 'olympicDark',
};
//# sourceMappingURL=olympic.js.map